import React, { useEffect, useState } from 'react';
// import ProjectList from './ProjectList';
import Button from '@mui/material/Button';
import { Box, Paper } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { Typography } from '@mui/material';
// import NewProject from './NewProject';
import { useAppDispatch } from '../../app/hooks';
import { fetchUsers } from '../UserManagement/UserSlice';
import HomeTiles from '../../components/layout/HomeTiles';
import Popup from '../Common/PopupFullScreen';
import CreateTimesheetsButton from './ButtonsIcon/LoanApplicationAgreementButton';
// import LendMoney from './ButtonsIcon/UploadLoanDocumentsButton';
import UploadLoanDocumentsButton from './ButtonsIcon/UploadLoanDocumentsButton';
import LoanApplicationAgreement from './ButtonsIcon/LoanApplicationAgreementButton';
import MyAccountInfoUpdate from './ButtonsIcon/SettingsAccountInformationButton';
import LoarAgreementForm from './LoanAgreement_Components/Forms/LoanAgreement';
import LoanApplicantsButton from './ButtonsIcon/LoanApplicantsButton';
import LoanRepayment_StatusButton from './ButtonsIcon/LoanRepayment_StatusButton';
// import Calendar from '../../views/application/calendar';


function HumanResourcesManagement() {
  const [showNew, setShowNew] = useState(false);
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(fetchUsers());
  }, []);

  const [project, setProject] = useState(null);

  return (
    <>
      <Box display="flex" flexDirection="column" height="100%">
        <Box display="flex" justifyContent="space-between" alignItems="center" mt={3}>
          <Box display="flex" alignItems="center" width="50%">

            <Typography
              className="bold-text"
              sx={{
                
                
                color: 'var(--color-ocean-highlight)',
                fontSize: '32px',
              
                
                height: '56px',
                maxWidth: '100%',
                mr: 2,
                ml:'20px',
              }}
              align="left"
              variant="h4"
              gutterBottom
            >
              Click on the service icon of interest:
            </Typography>

       
          </Box >

          <Box display="flex" alignItems="center" width="75%">
          <Typography
            className="bold-text"
            sx={{
              color: 'var(--color-ocean-highlight)',
              fontSize: '32px',
              ml:'10px'
     
            }}
            align="left"
            variant="h3"
            gutterBottom
          >
            Please ensure that your profile information is correct:
          </Typography>

          

          </Box>
        </Box>

        {/* This is creating the main two grey grids*/}

        <Box sx={{ display: 'flex' }}>

    
          <Box sx={{flexDirection: 'column', mr:'40px', width:"38%",display:'flex', height:'500px'}}>

              {/* This making sure that buttons are arranged in a grid */}
                <Box sx={{ display: 'flex' }}> 
                     

                  <Box sx={{mt:'20px', ml:'30px', flexDirection: 'column'}}>
                    <UploadLoanDocumentsButton /> 

                  
                  </Box>


                  <Box sx={{ mt:'20px', ml:'80px'}}>
                    
                    <LoanApplicationAgreement /> 
                  
                  </Box>

                </Box>


              {/* This making sure that buttons are arranged in a grid */}
              <Box sx={{ display: 'flex', mt:'50px' }}> 
                     

                <Box sx={{mt:'20px', ml:'30px', flexDirection: 'column'}}>
                  <LoanApplicantsButton />
                  {/* <LoarAgreementForm/> */}

                
                </Box>


                <Box sx={{ mt:'20px', ml:'80px'}}>
                  {/* <CreateTimesheetsButton />  */}
                  <LoanRepayment_StatusButton /> 
                
                </Box>
                

              </Box>

            {/* This making sure that buttons are arranged in a grid */}
            <Box sx={{ display: 'flex', mt:'50px' }}> 
        

                    <Box sx={{mt:'20px', ml:'30px', flexDirection: 'column'}}>
                    {/* <LoanRepayment_StatusButton />  */}
    
                    
                    </Box>
    
    
                    <Box sx={{ mt:'20px', ml:'5px'}}>
                     
                    <MyAccountInfoUpdate />
                    
                    </Box>
                    
    
                </Box>

               

            
            
          </Box>


          {/* This box is the greyed box */}
          <Box
            sx={{flexDirection: 'column', mr:'40px',backgroundColor: 'var(--color-dark-gray)', width:"50%", height:'500px'}}
          >





          </Box>
        </Box>

          
          

 
       
      </Box>

      {/* {showNew && <NewProject open={showNew} onClose={() => setShowNew(false)} />} */}
    </>
  );
}

export default HumanResourcesManagement;
